module.exports = __webpack_public_path__ + "img/fan_product-desc4.32175cca.png";